import importJs from '@/util/importJs.js';
import ajax from '@/plugins/ajax.js'

const jsApi = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';

export default {
    mounted() {
        var me = this, wx = window.wx;
        if (me.isWxWorkClient() || me.isWeixinClient()) {
            if (!wx || !wx.invoke) {
                importJs(jsApi, function () {
                    me.wxSetup();
                });
            } else {
                me.wxSetup();
            }
        }
    },
    methods: {
        /**
         * 企业微信客户端
         * @returns 
         */
        isWxWorkClient() {
            var ua = window.navigator.userAgent.toLowerCase();
            return ua.indexOf('wxwork/') > -1;
        },
        /**
         * 微信客户端
         * @returns 
         */
        isWeixinClient: function() {
            var ua = window.navigator.userAgent.toLowerCase();
            return ua.indexOf('micromessenger') > -1;
        },
        /**
         * 小程序环境
         * @returns 
         */
        isMiniProgram: function () {
            var wx = window.wx;
            return new Promise(function (resolve) {
                if (!wx || !wx.miniProgram) {
                    resolve(false);
                } else {
                    wx.miniProgram.getEnv((res) => {
                        resolve(res.miniprogram);
                    })
                }
            });
        },
        wxSetup() {
            var me = this, isWxWork = me.isWxWorkClient();
            me.getWxSignInfo().then(function (cfg) {
                window.wx.config(Object.assign({
                    beta: true,
                    debug: false,
                    jsApiList: isWxWork ? ['checkJsApi', 'shareAppMessage', 'shareWechatMessage', 'openLocation', 'getLocation', 'chooseInvoice'] :
                        ['chooseInvoice'],
                    openTagList: isWxWork ? [] :['wx-open-launch-app', 'wx-open-launch-weapp']
                }, cfg));
                me.wx_enabled = true;
                me.onWxEnabled && me.onWxEnabled();
            });
        },
        getWxSignInfo() {
            var me = this, isWxWork = me.isWxWorkClient();
            return ajax({
                url: isWxWork ? '/api/qywx/sign/jsapi' : '/api/weixin/sign/jsapi',
                params: {
                    url: window.location.href
                }
            }).then(function (res) {
                if (res.success) {
                    return res.data;
                }
            });
        },
        /**
         * 获取地理位置
         */
        getWxLocation() {
            var me = this;
            return new Promise(function (resolve, reject) {
                if (me.wx_enabled) {
                    window.wx.getLocation({
                        type: 'wgs84',
                        success: function (res) {
                            resolve(res);
                        },
                        cancel: function () {
                            reject();
                        }
                    });
                } else {
                    reject();
                }
            });
        },
        /**
         * 查看位置
         * @param {*} loc 
         */
        openWxLocation(loc) {
            window.wx.openLocation(Object.assign({
                latitude: 0,
                longitude: 0,
                name: '我的位置',
                scale: 15
            }, loc));
        },
        getWxInvoiceSign() {
            return ajax({
                url: '/api/qywx/invoice/sign'
            }).then(function (res) {
                if (res.success) {
                    return res.data;
                }
            });
        },
        getWxInvoiceInfo(req) {
            var me = this, isWxWork = me.isWxWorkClient();
            return ajax({
                url: isWxWork ? '/api/qywx/invoice/info' : '/api/weixin/invoice/info',
                method: 'POST',
                jsonData: req
            }).then(function (res) {
                if (res.success) {
                    return res.data;
                }
            });
        },
        /**
         * 拉起电子发票列表
         */
        chooseWxInvoice(resolve) {
            var me = this, isWxWork = me.isWxWorkClient(), callback = function(res){
                if (!res.choose_invoice_info) {
                    return;
                }
                var cardList = JSON.parse(res.choose_invoice_info);
                me.getWxInvoiceInfo(cardList).then(function(info){
                    resolve && resolve([cardList, info]);
                });
            };
            if (isWxWork) {
                me.getWxInvoiceSign().then(function (cfg) {
                    window.wx.invoke('chooseInvoice', cfg, callback);
                });
            } else {
                window.wx.invoke('chooseInvoice', {
                    timestamp: parseInt(new Date().getTime()/1000),
                    nonceStr: Math.random().toString(36).substr(2)
                }, callback);
            }
        },
    }
}